import { Chat } from '@/mocks/app/mockChatData';

/**
 * Atendimento "em espera": é o item que PISCA na lista — criado e ainda sem
 * atendente vinculado. Mesma leitura que o `selectChat` do chatStore faz para
 * decidir se o clique precisa de confirmação (ou de prévia, com
 * `inbox.ver_previa_atendimentos_em_espera`) antes de entrar no chat.
 *
 * Grupos nunca entram: não têm atendimento nem atendente vinculado.
 *
 * Bot ativo não atrapalha: ele pisca e segue esperando alguém assumir.
 *
 * IA é o único recorte: enquanto `idChatBotIa` está preenchido e
 * `statusIntegracaoIa` é nulo, o Agente ainda está conduzindo a conversa. Com
 * qualquer status (devolvido ao humano ou concluído pela IA), o atendimento
 * está de volta na fila.
 */
export function ehAtendimentoEmEspera(chat: Chat): boolean {
    if (chat.isGroup) return false;
    if (chat.status !== 'Criado') return false;
    if (chat.atendentes?.length) return false;

    return !chat.idChatBotIa || chat.statusIntegracaoIa != null;
}
